import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AddFundsButton, Heading, HeroNoSpacing } from '../common.js';
import { CpslButton } from '@usecapsule/react-components';
export const LoginDoneStep = ({ onClose }) => {
    return (_jsxs(_Fragment, { children: [_jsx(HeroNoSpacing, { icon: "heroWallet" }), _jsx(Heading, { style: { marginBottom: '24px' }, children: _jsx("span", { children: "You\u2019re Logged In!" }) }), _jsx(CpslButton, { fullWidth: true, onClick: onClose, children: "Close" }), _jsx(AddFundsButton, {})] }));
};
